<div
  class="border-standard-text-primary w-fit rounded-lg border p-1 px-2 text-sm"
  [attr.aria-label]="viaAriaLabel">
  {{ via().join(', ') }}
</div>
